import { React, useState } from "react";
import { Row, Col, Select, Button } from "antd";

const Filters = ({ onChange }) => {
  const [type, setType] = useState("HX_STD");
  const setFilters = () => {
    if (type) {
      onChange({
        type: type,
      });
    }
  };
  return (
    <Row gutter={24}>
      <Col span={5}>
        <Select
          placeholder="Teslimat Türü"
          style={{ width: "100%" }}
          options={[
            { label: "Standart Teslimat", value: "HX_STD" },
            { label: "XL Teslimat", value: "XL" },
          ]}
          value={type}
          onChange={setType}
        />
      </Col>

      <div style={{ width: 120 }}>
        <Button type="primary" block disabled={!type} onClick={setFilters}>
          Rapor Sorgula
        </Button>
      </div>
    </Row>
  );
};

export default Filters;
